import { PageLayout } from 'components/common';
import {
  ChatWidget,
  ColumnPanel,
  FilterPanel,
  Header,
  ListOrders,
  ListShipments,
  ViewPanel,
} from 'components/core';
import { OrderFilters, ShipmentFilters } from 'configurations';
import { useCallback, useContext, useState } from 'react';
import { ColumnContext, ListContext, ViewContext } from 'utils/context';
import { usePermissions } from 'utils/hooks';

import { Box, Flex } from '@project44/manifest-ds';

function ResultsPage() {
  const {
    flags: { featureExc2241 },
    permissions: { canViewChat, canViewOrders },
  } = usePermissions();
  const { setWillSearch, viewType } = useContext(ViewContext);
  const { totalCountOrders, totalCountShipments } = useContext(ListContext);
  const { updateColumns } = useContext(ColumnContext);
  const isOrder = canViewOrders && viewType === 'order';

  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isColumnOpen, setIsColumnOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isHeaderOpen] = useState(true);
  const [isViewOpen, setIsViewOpen] = useState(true);

  const handleToggleChat = useCallback(() => {
    setIsChatOpen((prev) => !prev);
  }, [setIsChatOpen]);

  return (
    <Box css={{ height: '100%' }}>
      <PageLayout
        header={
          <Header
            doSearch={setWillSearch}
            isChatOpen={isChatOpen}
            isColumnOpen={isColumnOpen}
            isFilterOpen={isFilterOpen}
            totalOrders={totalCountOrders}
            totalShipments={totalCountShipments}
            onClickChat={handleToggleChat}
            onClickColumn={() => {
              setIsColumnOpen((prev) => !prev);
              setIsFilterOpen(false);
            }}
            onClickFilter={() => {
              setIsColumnOpen(false);
              setIsFilterOpen((prev) => !prev);
            }}
          />
        }
        rightOpen={isFilterOpen}
        rightOpenTwo={isColumnOpen}
        rightPanel={[
          <FilterPanel
            doSearch={setWillSearch}
            filters={isOrder ? OrderFilters : ShipmentFilters}
            onClose={() => {
              setIsColumnOpen(false);
              setIsFilterOpen(false);
            }}
          />,
          <ColumnPanel
            isOrder={isOrder}
            updateColumns={updateColumns}
            onClose={() => {
              setIsColumnOpen(false);
              setIsFilterOpen(false);
            }}
          />,
        ]}
        leftOpen={isViewOpen}
        leftPanel={featureExc2241 ? <ViewPanel /> : undefined}
        setLeftOpen={setIsViewOpen}
        upOpen={isHeaderOpen}
        // setUpOpen={setIsHeaderOpen} // Disable Toggle Header
        content={
          <Flex
            css={{ padding: '0 $medium $medium', overflow: 'hidden', flex: 1 }}
          >
            {isOrder ? (
              <ListOrders doSearch={setWillSearch} />
            ) : (
              <Flex css={{ position: 'relative', width: '100%' }}>
                <ListShipments doSearch={setWillSearch} />
                {canViewChat && (
                  <ChatWidget
                    doSearch={setWillSearch}
                    isHidden={!isChatOpen}
                    onClose={() => setIsChatOpen(false)}
                  />
                )}
              </Flex>
            )}
          </Flex>
        }
      />
    </Box>
  );
}

export default ResultsPage;
